export default {
	'order.NoActivationAddress': '无激活地址！',
	'order.PleaseTryAgainLater': '请稍后重试',
	'order.toFillInTheShippingAddress': '去填写收货地址',
	'order.deactivateProduct': '去激活商品',
	'order.paymentSuccessful': '支付成功'
};
